import { css } from 'lit-element';

/*
This file is reserved for any custom css that developers want to add to
customize their theme. Simply add your css to this file and yarn build.
*/

export default css`
  * {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .nav-scroll {
    --nav-hover-bg-color: transparent;
    --nav-accent-color: #737373;
    --nav-hover-text-color: #1D1D1F;
    padding: 0 32px;
  }
  .nav-bar-info, .nav-bar-tag, .nav-bar-path {
    border: none !important;
    padding: 0;
  }
  .nav-bar-info {
    margin: 0 0 24px;
    font-weight: 400;
    font-size: 17px;
    line-height: 19px;
    color: var(--fg);
  }
  .nav-bar-info.active {
    font-weight: 600;
  }
  .nav-bar-info:hover {
    color: #534bc3;
  }
  .nav-bar-tag-and-paths {
    border-top: 1px solid #E5E5E5;
    padding: 20px 0;
  }
  .nav-bar-tag {
    text-transform: uppercase;
    font-weight: 600;
    font-size: 13px;
    line-height: 14px;
    letter-spacing: 0.06em;
  }
  .nav-bar-paths-under-tag {
    padding: 8px 0 11px;
  }
  .nav-bar-path {
    margin-top: 18px;
    font-size: 16px;
    line-height: 22px;
    color: var(--fg);
  }
  .nav-bar-path:hover {
    color: #534bc3;
  }
  #link-operations-top {
    display: none;
  }

  .tooltip-container {
    min-width: auto !important;
  }
  .tooltip {
    border: none;
  }
  .tooltip-text {
    background: #B6FCD2;
    border-radius: 4px;
    border: none !important;
    font-size: 16px;
    line-height: 25px;
    max-width: none;
    padding: 7px 14px 7px 6px !important;
    top: 50% !important;
    right: calc(100% + 14px) !important;
    transform: translateY(-50%);
    color: #1D1D1F !important;
    white-space: nowrap;
  }
  .tooltip-text::after {
    content: "";
    border-style: solid;
    border-width: 10px 0 10px 10px;
    border-color: transparent transparent transparent #B6FCD2;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 100%;
  }
  .expanded-endpoint-body {
    padding-top: 20px;
  }
  h3 {
    padding: 0 0 24px 0;
    margin: 0;
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #1D1D1F;
  }
  h2 {
    padding: 0 0 16px 0;
    margin: 0;
    font-weight: 600;
    font-size: 49px;
    line-height: 54px;
    letter-spacing: -0.04em;
    color: #000000;
  }
  .hf-endpoint {
    text-align:left;
    direction:ltr;
    margin: 0 0 23px !important;
    padding: 0 !important;
    padding: 0 0 32px 32px;
    align-items: center;
  }
  .hf-endpoint-path {
    font-family: var(--font-mono);
    font-size: 15px;
    line-height: 20px;
    margin-left: 5px;
  }
  .method-fg {
    display: inline-block;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    padding: 4px 8px;
    letter-spacing: 1px;
    border-radius: 6px;
  }
  .hf-endpoint.post .method-fg {
    color: #00B84E;
    background-color: #B6FCD2;
  }
  .hf-endpoint.get .method-fg {
    color: #00AAC2;
    background-color: #B9F6FF;
  }
  .hf-endpoint.delete .method-fg {
    color: #E44B36;
    background-color: #FFDDD6;
  }
  .hf-endpoint.patch .method-fg {
    color: #897E29;
    background-color: #E9E09A;
  }
  .hf-endpoint.put .method-fg {
    color: #E18600;
    background-color: #FFDFAE;
  }

  .hf-endpoint.post {

  }
  .hf-endpoint.get {

  }
  .hf-endpoint.delete {

  }
  .hf-endpoint.patch {

  }
  .hf-endpoint.put {

  }

  .tag-body {
    padding-top: 20px;
  }

  .page-tag {
    font-size: 16px;
    line-height: 18px;
    font-weight: 600;
    margin: 0 0 24px 0;
    padding: 0;
    letter-spacing: .06em;
    text-transform: uppercase;
  }

  .section-description {
    padding: 0 0 0 0;
  }

  .section-description p {
    font-size: 18px;
    line-height: 155%;
  }

  .request-panel, .response-panel {
    margin-top: 60px;
    border: none;
    padding: 0;
  }
  .req-res-title {
    font-weight: 600;
    font-size: 37.5334px;
    line-height: 41px;
    letter-spacing: -0.04em;
    color: #000000;
    margin-bottom: 16px;
  }
  .table-wrapper {
    background: #FCFCFC;
    border: 1px solid #E5E5E5;
    border-radius: 16px;
    padding: 32px;
    margin-left: -32px;
  }
  @media only screen and (max-width: 1024px) {
    .table-wrapper {
      margin-left: 0;
    }
  }
  .table-wrapper + .table-wrapper {
    margin-top: 28px !important;
  }
  .table-title {
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #1D1D1F;
    margin: 0;
    margin-bottom: 25px;
  }
  .table-title-type {
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    color: #8B8B8B;
    text-transform: initial;
  }
  .request-body-container > .table-title {
    padding-bottom: 28px;
  }
  .m-table {
    border: none;
    --font-size-small: 16px;
  }
  .m-table td, .m-table th {
    padding: 0 10px 0 0;
    border: none !important;
  }
  .m-table-delimiter-wrapper:last-child {
    display: none;
  }
  .m-table-delimiter {
    border-top: 1px solid #E5E5E5;
    padding-top: 36px;
    margin-top: 36px;
  }
  .param-name, .param-type {
    text-align: left;
  }
  .param-name {
    font-size: 18px;
    line-height: 20px;
    color: #1D1D1F;
  }
  .param-type {
    font-size: 16px;
    line-height: 22px;
    color: #8B8B8B;
  }
  .param-doc {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 10px;
    gap: 30px;
  }
  .param-doc .param-constraint {
    text-align: right;
  }
  .param-constraint {
    font-size: 16px;
    line-height: 22px;
    color: #8B8B8B;
  }
  .param-constraint-definition {
    color: #1D1D1F;
  }
  .request-param {
    font-size: 14px !important;
    line-height: 22px;
    color: #1D1D1F;
    height: 39px;
    padding: 8px 12px !important;
    background: #ECECEC;
    border-radius: 6px;
    border-color: #ECECEC;
  }
  .request-param:focus {
    border-color: #00B84E !important;
    background-color: transparent;
  }
  .request-param[type=file] {
    padding: 5px 0 0 4px !important;
    background: none;
  }
  .request-param[type=file]::file-selector-button {
    background-color: #524bbc;
    color: #FFF;
    border: 0;
    border-radius: 3px;
    padding: 2px 5px !important;
  }
  .tab-buttons {
    --light-fg: #8B8B8B;
    --font-size-small: 16px;
  }
  .tab-btn {
    border-bottom: 4px solid transparent !important;
    border-radius: 0;
    font-weight: normal !important;
    font-size: 16px;
    color: #8B8B8B;
    padding: 0 0 8px;
  }
  .tab-btn.active {
    color: #534BC3;
    border-bottom-color: #534BC3 !important;
  }
  .toolbar {
    padding: 34px 0 0 0;
  }
  .toolbar-item {
    font-weight: normal;
    font-size: 16px;
    line-height: 25px;
    padding: 0;
  }
  .schema-root-type {
    font-weight: normal;
    font-size: 18px;
    line-height: 28px;
    text-transform: initial;
  }
  .tree {
    color: #FFFFFF;
    --hover-color: transparent;
    --font-size-small: 16px;
  }
  .tree > .m-markdown > p {
    font-weight: normal;
    font-size: 18px;
    line-height: 28px;
    color: #8B8B8B;
    margin: 0;
  }
  .collapsed-descr .tr {
    max-height: 27px;
  }
  .schema-wrapper {
    background: #121212;
    border-radius: 10px;
    padding: 32px;
    margin-top: 12px;
  }
  .key {
    font-size: 12.5px;
    line-height: 25px;
  }
  .deci .blue, .doub, .floa, .int3, .int6, .inte, .numb, .number {
    color: var(--red);
  }
  .bina, .byte, .date, .emai, .host, .ipv4, .pass, .stri, .string, .uri, .url, .uuid {
    color: #8B86E7;
  }
  .key-descr {
    font-weight: normal;
    font-size: 14px;
    line-height: 25px;
    color: #A6A6A6;
  }
  .m-markdown-small p {
    font-weight: normal;
    font-size: 16px;
    line-height: 25px;
  }
  .key-descr .m-markdown-small p,
  .key-descr.m-markdown-small p {
    font-size: 14px;
  }
  .tree .m-markdown-small a {
    color: #EA7523;
  }
  .tree .tr.primitive:hover {
    background: rgba(255, 255, 255, 0.1);
  }
  .example > .m-markdown-small {
    color: #8B8B8B;
    padding: 12px 0 0 !important;
  }
  .request-body-param-user-input, .json-tree {
    background: #121212;
    border-radius: 10px;
    padding: 32px;
    border: none;
    font-size: 13px;
    line-height: 22px;
    color: #FFFFFF;
    --fg: #FFFFFF;
    margin-top: 12px;
  }
  .json-tree {
    --hover-color: transparent;
  }
  .api-call-info {
    width: 100% !important;
    padding-bottom: 25px;
    font-weight: normal;
    font-size: 16px;
    line-height: 25px;
    color: #1D1D1F;
    --light-fg: #8B8B8B;
  }
  .m-btn {
    font-weight: 500;
    font-size: 18px;
    padding: 0 14px;
    height: 39px;
    border: 1px solid transparent;
    border-radius: 4px;
    box-shadow: none;
    transition: background-color 0.2s ease 0s, border-color 0.2s ease 0s;
  }
  .m-btn.thin-border
  {
    border-color: #E5E5E5;
    color: #1D1D1F;
  }
  .m-btn.thin-border:hover {
    border-color: #BEBEBE;
    background-color: transparent;
  }
  .m-btn.primary {
    background-color: #00B84E;
    border-color: #00B84E;
    color: #FFFFFF;
  }
  .m-btn.primary:hover {
    background-color: #00971B;
    border-color: #00971B;
  }
  .m-btn.small {
    font-size: 14px;
    height: 24px;
  }
  .response-message {
    font-weight: normal;
    font-size: 16px;
    line-height: 25px;
    --blue: #00AAC2;
    --light-fg: #1D1D1F;
  }
  .m-markdown pre {
    background: #121212;
    border-radius: 10px;
    padding: 32px;
    border: none;
    color: #FFFFFF;
    margin-top: 16px;
  }
  .response-success {
    border: 2px solid #00B84E !important;
    color: #00B84E;
  }
  .response-success.primary, .response-success:hover {
    background-color: #00B84E !important;
    color: #FFFFFF;
  }
  .response-error {
    border: 2px solid #FF8E7D !important;
    color: #FF8E7D;
  }
  .response-error.primary, .response-error:hover {
    background-color: #FF8E7D !important;
    color: #FFFFFF;
  }
  .response-panel .resp-descr {
    margin: 28px 0 8px;
  }
  .response-panel .resp-descr p {
    font-weight: normal;
    font-size: 16px;
    line-height: 25px;
    color: #8B8B8B;
  }

  a {
    text-decoration: none !important;
  }

  /*
    HEADER
  */
  .header-scope *,
  .header-scope *::before,
  .header-scope *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    outline: 0;
    font-weight: 500;
  }
  .header-scope button,
  .header-scope input,
  .header-scope select,
  .header-scope textarea {
    border: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: none;
    color: inherit;
    font: inherit;
  }
  
  /* Menu */
  .header-scope .menu-icon {
    position: relative;
    display: inline-block;
  }
  .header-scope .menu-icon > rect {
    position: absolute;
    fill: #999;
    transform-origin: center;
    transition: all 0.1s;
  }
  @media (hover: hover) {
    .header-scope .menu-icon:hover > rect {
      fill: #1d1d1f;
    }
  }
  
  /* Navigation */
  .header-scope .navigation {
    display: flex;
  }
  @media (max-width: 1024px) {
    .header-scope .navigation {
      padding-right: 40px;
    }
  }
  .header-scope .navigation__list {
    font-size: 16px;
    line-height: 1;
    display: flex;
    align-items: center;
    margin: 0;
  }
  .header-scope .navigation__list > li {
    display: none;
  }
  @media (min-width: 1025px) {
    .header-scope .navigation__list > li {
      display: block;
    }
  }
  @media (min-width: 861px) {
    .header-scope .navigation__list > li.is-button {
      display: block;
    }
  }
  .header-scope .navigation__list > li a {
    white-space: nowrap;
  }
  .header-scope .navigation__list > li a:not(.button) {
    color: #1d1d1f;
  }
  @media (hover: hover) {
    .header-scope .navigation__list > li a:not(.button):not([disabled]):hover {
      color: #534bc3;
    }
    .header-scope .navigation__list > li a:not(.button):not([disabled]):active {
      color: #534bc3;
    }
  }
  .header-scope .navigation__list > li .button {
    transition-property: background-color;
  }
  .header-scope .navigation__list > li:not(:last-child) {
    margin-right: 24px;
  }
  .header-scope .navigation__list > li:not(:last-child) .button {
    margin-right: -16px;
  }
  .header-scope .navigation__menu-button {
    width: 64px;
    height: 64px;
    position: absolute;
    top: 50%;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    cursor: pointer;
    transform: translateY(-50%);
  }
  @media (min-width: 1025px) {
    .header-scope .navigation__menu-button {
      display: none;
    }
  }
  .header-scope .navigation--modal .navigation__menu-button {
    z-index: 2001;
  }
  @media (min-width: 1025px) {
    .header-scope .navigation--modal .navigation__menu-button {
      display: block;
    }
  }
  .header-scope .navigation--modal .menu-icon > rect:nth-child(1),
  .header-scope .navigation--modal .menu-icon > rect:nth-child(4) {
    opacity: 0;
    transform: scaleX(0);
  }
  .header-scope .navigation--modal .menu-icon > rect:nth-child(2) {
    transform: rotate(45deg);
  }
  .header-scope .navigation--modal .menu-icon > rect:nth-child(3) {
    transform: rotate(-45deg);
  }
  .header-scope .navigation--modal .navigation__list {
    font-size: 24px;
    line-height: 1.25;
    position: fixed;
    z-index: 2000;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: block;
    padding: 32px;
    background-color: #fff;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .header-scope .navigation--modal .navigation__list > li {
    display: block;
  }
  .header-scope .navigation--modal .navigation__list > li > a,
  .header-scope .navigation--modal .navigation__list > li > button {
    display: inline-block;
    -webkit-animation: navigationListItemsShow 0.5s ease-out 0.1s forwards;
    animation: navigationListItemsShow 0.5s ease-out 0.1s forwards;
    opacity: 0;
    transform: translateY(20px);
  }
  @-webkit-keyframes navigationListItemsShow {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  @keyframes navigationListItemsShow {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .header-scope .navigation--modal .navigation__list > li .button {
    font-size: 24px;
    line-height: 1.25;
    color: #1d1d1f;
    padding: unset;
    margin-right: unset;
    background-color: unset;
    transition: unset;
  }
  @media (hover: hover) {
    .header-scope .navigation--modal .navigation__list > li .button:not([disabled]):hover {
      color: #534bc3;
    }
    .header-scope .navigation--modal .navigation__list > li .button:not([disabled]):active {
      color: #534bc3;
    }
  }
  .header-scope .navigation--modal .navigation__list > li .button.button--primary {
    color: #16bf54;
  }
  @media (hover: hover) {
    .header-scope .navigation--modal .navigation__list > li .button.button--primary:not([disabled]):hover {
      color: #00a83e;
    }
    .header-scope .navigation--modal .navigation__list > li .button.button--primary:not([disabled]):active {
      color: #00a83e;
    }
  }
  .header-scope .navigation--modal .navigation__list > li:not(:last-child) {
    margin-right: unset;
    margin-bottom: 16px;
  }
  .header-scope .navigation--modal .navigation__list--opening {
    -webkit-animation: navigationListOpening 0.1s;
    animation: navigationListOpening 0.1s;
  }
  @-webkit-keyframes navigationListOpening {
    0% {
      display: none;
      opacity: 0;
    }
    1% {
      display: block;
      opacity: 0;
    }
    100% {
      display: block;
      opacity: 1;
    }
  }
  @keyframes navigationListOpening {
    0% {
      display: none;
      opacity: 0;
    }
    1% {
      display: block;
      opacity: 0;
    }
    100% {
      display: block;
      opacity: 1;
    }
  }
  .header-scope .navigation--modal .navigation__list--closing {
    -webkit-animation: navigationListClosing 0.1s;
    animation: navigationListClosing 0.1s;
  }
  @-webkit-keyframes navigationListClosing {
    0% {
      display: flex;
      opacity: 1;
    }
    99% {
      display: flex;
      opacity: 0;
    }
    100% {
      display: none;
      opacity: 0;
    }
  }
  @keyframes navigationListClosing {
    0% {
      display: flex;
      opacity: 1;
    }
    99% {
      display: flex;
      opacity: 0;
    }
    100% {
      display: none;
      opacity: 0;
    }
  }
  
  /* Header */
  .header-scope .header {
    position: relative;
    z-index: 1000;
    display: flex;
    height: 64px;
    align-items: center;
    padding: 0 20px;
    background-color: #fff;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);
  }
  @media (min-width: 861px) {
    .header-scope .header {
      height: 72px;
      padding: 0 24px;
    }
  }
  .header-scope .header__logo {
    display: block;
    position: relative;
  }
  .header-scope .header__logo:not(:last-child) {
    margin-right: 20px;
  }
  @media (min-width: 861px) {
    .header-scope .header__logo:not(:last-child) {
      margin-right: 24px;
    }
  }
  .header-scope .header__logo img {
    vertical-align: top;
    height: 44px;
  }
  .header-scope .header__logo video {
    position: absolute;
    height: 42px;
    left: 1px;
    top: 1px;
    border-radius: 50%;
  }
  @media (max-width: 860px) {
    .header-scope .header__logo img {
      vertical-align: top;
      height: 32px;
    }

    .header-scope .header__logo video {
      height: 30px;
    }

    .header-scope .header__logo img:nth-of-type(2) {
      display: none;
    }
  }
  @media (min-width: 861px) {
    .header-scope .header__logo img:nth-of-type(1) {
      display: none;
    }
  }
  .header-scope .header__content {
    margin-left: auto;
  }
  
  /* Container */
  .header-scope .container {
    max-width: 420px;
    padding-right: 30px;
    padding-left: 30px;
    width: 100%;
    margin-right: auto;
    margin-left: auto;
  }
  @media (min-width: 861px) {
    .header-scope .container {
      max-width: 1040px;
    }
  }
  @media (min-width: 861px) {
    .header-scope .container {
      padding-right: 60px;
    }
  }
  @media (min-width: 1025px) {
    .header-scope .container {
      padding-right: 20px;
    }
  }
  @media (min-width: 861px) {
    .header-scope .container {
      padding-left: 60px;
    }
  }
  @media (min-width: 1025px) {
    .header-scope .container {
      padding-left: 20px;
    }
  }
  
  /* Button */
  .header-scope .button {
    font-size: 16px;
    line-height: 1;
    padding: 16px 24px;
    background-color: #1d1d1f;
    border-radius: 6px;
    color: #f4f3eb;
    text-align: center;
    transition: all 0.2s;
    white-space: nowrap;
  }
  @media (hover: hover) {
    .header-scope .button:not([disabled]):hover {
      background-color: #000;
      color: #fff;
    }
    .header-scope .button:not([disabled]):active {
      background-color: #000;
      color: #fff;
    }
  }
  .header-scope .button[type=button] {
    cursor: pointer;
  }
  .header-scope .button[disabled] {
    cursor: not-allowed;
    opacity: 0.5;
  }
  .header-scope a.button {
    display: inline-block;
    text-decoration: none;
  }

  .header-scope .button--block {
    display: block;
    width: 100%;
  }
  .header-scope .button--sm {
    padding: 8px 24px;
    border-radius: 3px;
  }
  .header-scope .button--lg {
    padding: 17px 24px;
  }
  @media (min-width: 861px) {
    .header-scope .button--lg {
      font-size: 19px;
      line-height: 20px;
      padding-right: 40px;
      padding-left: 40px;
    }
  }
  .header-scope .button--xl {
    padding: 18px 32px;
  }
  @media (min-width: 861px) {
    .header-scope .button--xl {
      font-size: 22px;
      line-height: 1;
      padding-top: 22px;
      padding-bottom: 22px;
    }
  }
  .header-scope .button--primary {
    background-color: #16bf54;
    color: #fff;
  }
  @media (hover: hover) {
    .header-scope .button--primary:not([disabled]):hover {
      background-color: #00a83e;
    }
    .header-scope .button--primary:not([disabled]):active {
      background-color: #00a83e;
    }
  }
  
  /* Privacy policy */
  .header-scope .privacy-policy {
    font-size: 12px;
    line-height: 1.4;
    color: #b2b3ad;
    font-weight: 400;
  }
  @media (min-width: 861px) {
    .header-scope .privacy-policy {
      font-size: 14px;
      line-height: 1.5;
      text-align: center;
    }
  }
  .header-scope .privacy-policy a {
    color: #b2b3ad;
    font-weight: normal;
    text-decoration: underline !important;
  }
  @media (hover: hover) {
    .header-scope .privacy-policy a:not([disabled]):hover {
      color: #ffb800;
    }
    .header-scope .privacy-policy a:not([disabled]):active {
      color: #ffb800;
    }
  }
  
  /* Form */
  @media (min-width: 861px) {
    .header-scope .form-block__column {
      width: 75%;
      margin-right: auto;
      margin-left: auto;
    }
  }
  @media (min-width: 1025px) {
    .header-scope .form-block__column {
      width: 50%;
      margin-right: auto;
      margin-left: auto;
    }
  }
  .header-scope .form-block__header {
    margin-bottom: 24px;
    text-align: center;
  }
  @media (min-width: 861px) {
    .header-scope .form-block__header {
      margin-bottom: 28px;
    }
  }
  .header-scope .form-block__title {
    padding: 0;
    font-weight: 500;
    font-size: 23px;
    line-height: 1.24;
    letter-spacing: -0.02em;
    text-transform: none;
  }
  @media (min-width: 861px) {
    .header-scope .form-block__title {
      font-size: 38px;
      line-height: 1.2;
    }
  }
  @media (min-width: 1025px) {
    .header-scope .form-block__title {
      line-height: 1.14;
    }
  }
  .header-scope .form-block__title > span {
    display: inline;
    overflow: hidden;
    padding: 0 2px 2px;
    margin: 0 -2px;
    background: linear-gradient(to bottom, transparent 0%, transparent 50%, #ffe079 50%, #ffe079 100%);
    -webkit-box-decoration-break: clone;
    box-decoration-break: clone;
    content: "";
    pointer-events: none;
  }
  @media (min-width: 861px) {
    .header-scope .form-block__title > span {
      padding: 0 4px 4px;
      margin: 0 -4px;
    }
  }
  .header-scope .form-block__caption {
    margin-top: 8px;
    color: #6d6d6f;
    font-weight: 400;
  }
  .header-scope .form-block__agreement {
    margin-top: 16px;
  }
  @media (min-width: 861px) {
    .header-scope .form-block__agreement {
      margin-top: 20px;
    }
  }
  .header-scope .form-block__notice {
    margin-top: 24px;
  }
  @media (min-width: 861px) {
    .header-scope .form-block__notice {
      margin-top: 108px;
    }
  }

  .header-scope .form__row {
    margin-bottom: 15px;
  }
  @media (min-width: 861px) {
    .header-scope .form__row {
      margin-bottom: 20px;
    }
  }
  .header-scope .form__row--hidden {
    display: none;
  }
  .header-scope .form__submit {
    margin-top: 20px;
  }
  @-webkit-keyframes spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .header-scope .form.is-sending::before, .form.is-sending::after {
    content: "";
  }
  .header-scope .form.is-sending::before {
    position: absolute;
    z-index: 4;
    background-color: rgba(255, 255, 255, 0.5);
    inset: 0;
  }
  .header-scope .form.is-sending::after {
    width: 64px;
    height: 64px;
    position: absolute;
    z-index: 5;
    top: calc(50% - 64px / 2);
    left: calc(50% - 64px / 2);
    display: block;
    border-width: 6px;
    border-style: solid;
    border-color: #16bf54 transparent #16bf54 transparent;
    -webkit-animation: spinner 1.2s linear infinite;
    animation: spinner 1.2s linear infinite;
    border-radius: 50%;
    content: "";
  }
  .header-scope .form-success {
    position: absolute;
    z-index: 0;
    display: none;
    background-color: #f7f6ee;
    inset: 0;
    text-align: center;
  }
  @media (min-width: 861px) {
    .header-scope .form-success__content {
      width: 75%;
      margin-right: auto;
      margin-left: auto;
    }
  }
  @media (min-width: 1025px) {
    .header-scope .form-success__content {
      width: 50%;
      margin-right: auto;
      margin-left: auto;
    }
  }
  .header-scope .form-success__title {
    font-weight: 500;
  }
  .header-scope .form-success__title > span {
    display: inline;
    overflow: hidden;
    padding: 0 2px 2px;
    margin: 0 -2px;
    background: linear-gradient(to bottom, transparent 0%, transparent 50%, #ffe079 50%, #ffe079 100%);
    -webkit-box-decoration-break: clone;
    box-decoration-break: clone;
    content: "";
    pointer-events: none;
  }
  @media (min-width: 861px) {
    .header-scope .form-success__title > span {
      padding: 0 4px 4px;
      margin: 0 -4px;
    }
  }
  .header-scope .form-success__caption {
    font-size: 13px;
    line-height: 1.45;
    font-weight: 500;
  }
  @media (min-width: 861px) {
    .header-scope .form-success__caption {
      font-size: 15px;
    }
  }
  @media (min-width: 1025px) {
    .header-scope .form-success__caption {
      font-size: 18px;
    }
  }
  @media (min-width: 861px) {
    .header-scope .form-success__caption {
      line-height: 1.55;
    }
  }
  @media (min-width: 1025px) {
    .header-scope .form-success__caption {
      line-height: 1.55;
    }
  }
  .header-scope .form-success__caption:not(:first-child),
  .header-scope .form-success__button:not(:first-child) {
    margin-top: 28px;
  }
  .header-scope .form-success__caption:not(:last-child),
  .header-scope .form-success__button:not(:last-child) {
    margin-bottom: 28px;
  }
  .header-scope .form-success__button {
    display: none;
  }
  .header-scope .form.is-success .form-success {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .header-scope .input,
  .header-scope .textarea {
    font-size: 16px;
    line-height: 1;
    display: block;
    width: 100%;
    padding: 15px;
    border: 1px solid #f5f5f5;
    background-color: #f5f5f5;
    border-radius: 6px;
    font-weight: 500;
    outline: none;
    transition: border 0.2s;
  }
  @media (min-width: 861px) {
    .header-scope .input,
    .header-scope .textarea {
      font-size: 19px;
      line-height: 20px;
      padding-top: 19px;
      padding-bottom: 19px;
    }
  }
  .header-scope .input:focus,
  .header-scope .textarea:focus,
  .header-scope .input:active,
  .header-scope .textarea:active {
    border-color: #16bf54;
  }
  .header-scope .input::-moz-placeholder,
  .header-scope .textarea::-moz-placeholder {
    color: #b5b5b5;
  }
  .header-scope .input:-ms-input-placeholder,
  .header-scope .textarea:-ms-input-placeholder {
    color: #b5b5b5;
  }
  .header-scope .input::placeholder,
  .header-scope .textarea::placeholder {
    color: #b5b5b5;
  }
  .header-scope label .input,
  .header-scope label .textarea {
    margin-top: 8px;
  }

  .header-scope .label {
    font-size: 13px;
    line-height: 1.45;
    font-weight: 400;
    display: block;
  }
  @media (min-width: 861px) {
    .header-scope .label {
      font-size: 15px;
    }
  }
  @media (min-width: 1025px) {
    .header-scope .label {
      font-size: 18px;
    }
  }
  @media (min-width: 861px) {
    .header-scope .label {
      line-height: 1.55;
    }
  }
  @media (min-width: 1025px) {
    .header-scope .label {
      line-height: 1.55;
    }
  }

  .header-scope .textarea {
    resize: none;
  }
  
  /* Modal */
  .header-scope .close-icon {
    stroke: #534bc3;
  }

  .header-scope .modal {
    position: fixed;
    z-index: 3000;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: none;
    background-color: #fff;
    opacity: 0;
    overflow-x: hidden;
    overflow-y: auto;
    pointer-events: none;
    transition: opacity 0.1s;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    will-change: opacity;
  }
  .header-scope .modal__logo {
    position: fixed;
    z-index: 1;
    top: 0;
    left: 24px;
    display: flex;
    height: 72px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  @media (max-width: 860px) {
    .header-scope .modal__logo {
      display: none;
    }
  }
  .header-scope .modal__logo img {
    filter: grayscale(100%) opacity(0.1);
    transition: filter 0.2s;
    vertical-align: top;
    height: 44px;
  }
  .header-scope .modal__logo:hover img {
    filter: unset;
  }
  .header-scope .modal__close-button {
    width: 60px;
    height: 60px;
    position: fixed;
    z-index: 1;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .header-scope .modal__close-button .close-icon {
    opacity: 0.2;
    transition: opacity 0.1s;
  }
  .header-scope .modal__close-button:hover .close-icon {
    opacity: 1;
  }
  .header-scope .modal__content {
    flex: 1;
    padding: 64px 0;
    margin: auto;
  }
  @media (min-width: 861px) {
    .header-scope .modal__content {
      padding: 72px 0;
    }
  }
  .header-scope .modal--open {
    display: flex;
    opacity: 1;
    pointer-events: unset;
    -webkit-user-select: unset;
    -moz-user-select: unset;
    -ms-user-select: unset;
    user-select: unset;
  }
  @-webkit-keyframes modalFadeIn {
    0% {
      display: none;
      opacity: 0;
    }
    1% {
      display: flex;
      opacity: 0;
    }
    100% {
      display: flex;
      opacity: 1;
    }
  }
  @keyframes modalFadeIn {
    0% {
      display: none;
      opacity: 0;
    }
    1% {
      display: flex;
      opacity: 0;
    }
    100% {
      display: flex;
      opacity: 1;
    }
  }
  @-webkit-keyframes modalFadeOut {
    0% {
      display: flex;
      opacity: 1;
    }
    99% {
      display: flex;
      opacity: 0;
    }
    100% {
      display: none;
      opacity: 0;
    }
  }
  @keyframes modalFadeOut {
    0% {
      display: flex;
      opacity: 1;
    }
    99% {
      display: flex;
      opacity: 0;
    }
    100% {
      display: none;
      opacity: 0;
    }
  }
  .header-scope .modal--fade-in {
    -webkit-animation: modalFadeIn 0.2s forwards;
    animation: modalFadeIn 0.2s forwards;
  }
  .header-scope .modal--fade-out {
    -webkit-animation: modalFadeOut 0.2s forwards;
    animation: modalFadeOut 0.2s forwards;
  }
  .header-scope .modal .form-success {
    background-color: #fff;
  }
  .header-scope .modal .form-success__button {
    display: initial;
  }
  
  /* API */
  @media (max-width: 1279px) {
    .header-scope .navigation {
      padding-right: 40px;
    }
  }
  @media (min-width: 1280px) {
    .header-scope .navigation {
      padding-right: 0;
    }
  }
  @media (max-width: 1279px) {
    .header-scope .navigation__list > li {
      display: none;
    }
  }
  @media (min-width: 1280px) {
    .header-scope .navigation__list > li {
      display: block;
    }
  }
  @media (max-width: 1279px) {
    .header-scope .navigation__menu-button {
      display: flex;
    }
  }
  @media (min-width: 1280px) {
    .header-scope .navigation__menu-button {
      display: none;
    }
  }

  .header-scope .form-block--sandbox {
    position: relative;
  }
`;
